/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useRef } from 'react';
import { Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import { Section } from 'services/systems/types';

interface PricingPlan {
  name: string;
  price: number;
  priceOff?: number;
  period?: string;
  buttonText: string;
}

interface PricingTableProps {
  hideHeader?: boolean;
  table: Section;
  plans: PricingPlan[];
  selectedPlanIndex: number;
  isMobile?: boolean;
}

const PricingTable: React.FC<PricingTableProps> = ({
  hideHeader,
  table,
  plans,
  selectedPlanIndex,
  isMobile,
}) => {
  const headerRefs = useRef<(HTMLTableCellElement | null)[]>([]);

  const featureMap = table.items.map((feature) => ({
    name: feature.name,
    note: feature.description,
    availability: feature.details,
  }));

  return (
    <div className="p-pricingPlan_table">
      <div className="p-pricingPlan_table_header">
        <Image className="p-pricingPlan_table_icon" src={table.icon} alt="Pricing Table" ratio="1x1" />
        <Typography.Text fontweight="600" extendClasses="p-pricingPlan_table_title fs-24x30">
          {table.name}
        </Typography.Text>
      </div>
      <div className="p-pricingPlan_table_wrapper">
        <table className="p-pricingPlan_table_table">
          {!hideHeader && (
            <thead>
              <tr>
                {isMobile ? (
                  <th className="p-pricingPlan_table_planHeader">{plans[selectedPlanIndex].name}</th>
                ) : (
                  plans.map((plan, index) => (
                    <th
                      key={`plan-${index}`}
                      className="p-pricingPlan_table_planHeader"
                      ref={(el) => (headerRefs.current[index] = el)}
                    />
                  ))
                )}
              </tr>
            </thead>
          )}
          <tbody>
            {featureMap.map((feature, rowIndex) => (
              <tr key={`feature-${rowIndex}`}>
                <td className="p-pricingPlan_table_feature">
                  <div className="p-pricingPlan_table_featureContainer">
                    <Typography.Text extendClasses="p-pricingPlan_table_featureName">
                      {feature.name}
                    </Typography.Text>
                    {feature.note && (
                      <Tooltip title={feature.note}>
                        <QuestionCircleOutlined aria-label={`Description for ${feature.name}`} />
                      </Tooltip>
                    )}
                  </div>
                </td>
                {isMobile ? (
                  <td align="center" className="p-pricingPlan_table_check">
                    <div className="p-pricingPlan_table_checkIcon">
                      {table.type !== 'string' ? (
                        <Icon
                          iconName={feature.availability[selectedPlanIndex] ? 'checkLightGreen' : 'dashGrey'}
                          size="28"
                          aria-label={feature.availability[selectedPlanIndex] ? 'Available' : 'Not available'}
                        />
                      ) : (
                        !feature.availability[selectedPlanIndex] ? (
                          <Icon iconName="dashGrey" size="28" aria-label="Not available" />
                        ) : (
                          <Typography.Text extendClasses="p-pricingPlan_table_checkText">
                            {feature.availability[selectedPlanIndex]}
                          </Typography.Text>
                        )
                      )}
                    </div>
                  </td>
                ) : (
                  feature.availability.map((isAvailable, colIndex) => (
                    <td align="center" key={`plan-${colIndex}`} className="p-pricingPlan_table_check">
                      <div className="p-pricingPlan_table_checkIcon">
                        {table.type !== 'string' ? (
                          <Icon
                            iconName={isAvailable ? 'checkLightGreen' : 'dashGrey'}
                            size="28"
                            aria-label={isAvailable ? 'Available' : 'Not available'}
                          />
                        ) : (
                          !isAvailable ? (
                            <Icon iconName="dashGrey" size="28" aria-label="Not available" />
                          ) : (
                            <Typography.Text extendClasses="p-pricingPlan_table_checkText">
                              {isAvailable}
                            </Typography.Text>
                          )
                        )}
                      </div>
                    </td>
                  ))
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PricingTable;
